module.exports = __webpack_public_path__ + "static/media/case1.3f1a0624.jpg";